export default __webpack_public_path__ + "static/media/IconFilter.870c4219.svg";